import Link from 'next/link'
import { Text } from '../../../../styles/typography'

const Contact = () => {
  return (
    <div className='contact'>
      <Link href='/support'>
        <Text>
          Have questions? <span>Contact Support</span>.
        </Text>
      </Link>
    </div>
  )
}

export default Contact
